import React from 'react';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';


const CTAWrapper = styled.section`
  background: linear-gradient(to right, #119687, #0e736a);
  color: #fff;
  padding: 4rem 1rem;
  text-align: center;
`;

const CTAContent = styled.div`
  max-width: 700px;
  margin: 0 auto;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 2rem;
  }

  a.btn {
    font-size: 1rem;
    font-weight: bold;
    border-radius: 30px;
    padding: 0.75rem 2rem;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 2rem;
    }

    p {
      font-size: 1rem;
    }
  }
`;

const CallToAction = () => {
  const church = JSON.parse(localStorage.getItem('church')) || {};

  return (
    <CTAWrapper>
        
      <CTAContent>
        <h2>{church.cta_title || "You're Welcome Here"}</h2>
        <p>
          {church.cta_text ||
            "Join us this Sunday or get in touch to learn more about our community. We’d love to connect with you!"}
        </p>
        <Button href={church.cta_button_link || "/contact"} variant="light">
          {church.cta_button_text || "Get Connected"}
        </Button>
      </CTAContent>
    </CTAWrapper>
  );
};

export default CallToAction;
